<script setup>
import { useAuthStore } from "@/store/auth"
import ScrollToTop from '@core/components/ScrollToTop.vue'
import initCore from '@core/initCore'
import {
  initConfigStore,
  useConfigStore,
} from '@core/stores/config'
import { hexToRgb } from '@layouts/utils'
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useTheme } from 'vuetify'

const { global } = useTheme()

// ℹ️ Sync current theme with initial loader theme
initCore()
initConfigStore()

const configStore = useConfigStore()

//added by abdullah 
const loading = ref(false)
const router = useRouter()
const authStore = useAuthStore() 

// Set inactivity limit to 20 minutes (20 * 60 * 1000 milliseconds)
const inactivityLimit = 60 * 60 * 1000
let inactivityTimeout = null


function resetInactivityTimeout() {

  // Clear the timeout if there's any user activity
  if (inactivityTimeout) {
    clearTimeout(inactivityTimeout)
  }

  // Set a new timeout to trigger logout after inactivity
  const storedToken = localStorage.getItem('token')

  setTimeout(logoutUser, inactivityLimit)
  if(storedToken){}
}




const logoutUser = async () => {
  // try {
   
  //   const token = localStorage.getItem('token') 

  //   if (!token) {
  //     throw new Error('No authentication token found.')
  //   }

  //   const response = await fetch(`${ import.meta.env.VITE_API_URL}logout`, {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Authorization': `Bearer ${token}`, // Pass the token in the Authorization header
  //     },
  //     credentials: 'include', // Ensures cookies are sent with the request if necessary
  //   })
    
  //   if (!response.ok) {
  //     throw new Error(`Logout failed: ${response.statusText}`)
  //   }

    
   
    
  // } catch (error) {
  //   console.error('Error during logout:', error)
  // }

  authStore.logout(router)


}


onMounted(() => {
  // Show spinner before each route change
  router.beforeEach((to, from, next) => {
    loading.value = true
    next()
  })
  window.addEventListener('mousemove', resetInactivityTimeout)
  window.addEventListener('keydown', resetInactivityTimeout)

  // Start the inactivity timeout on mount
  resetInactivityTimeout()

  // Show w.removeEventListener('keydown', resetInactivityTimeout)

  if (inactivityTimeout) {
    clearTimeout(inactivityTimeout)
  }
}),

// Hide spinner after route change
router.afterEach(() => {
  loading.value = false
  resetInactivityTimeout()
})
</script>

<template>
  <Spinner :visible="loading" />
  <VLocaleProvider :rtl="configStore.isAppRTL">
    <!-- ℹ️ This is required to set the background color of active nav link based on currently active global theme's primary -->
    <VApp :style="`--v-global-theme-primary: ${hexToRgb(global.current.value.colors.primary)}`">
      <RouterView />

      <ScrollToTop />
    </VApp>
  </VLocaleProvider>
</template>
